import { set, toggle } from '@/utils/vuex';
import defaultState from "./state";

export default {
  resetState: state => state = Object.assign({}, defaultState),
  forceUpdate: state => state.types = JSON.parse(JSON.stringify(state.types)),
  clearSelected: state => state.selected = [],
  clearTags: state => {
    state.tags = {}
    state.types = defaultState.types
  },
  setTag (state, item) {
    state.tags[item.name] = item
    state.count++
  },
  resetCounter (state) {
    for (var type in state.types) {
        for (var tag in state.types[type].tags){
          state.types[type].tags[tag].count = 0
        }
      }
  },
  setCount(state, item) {
     state.tags[item.name] = item
    if (state.types[item.type]) state.types[item.type].tags[item.name]= item
    //state.count++
  },
  setList (state, list) {
    list.forEach(function(type){
        if (state.types[type.name]) {
          type.tags.forEach(function(item){
            state.tags[item.name] = item
            state.types[type.name].tags[item.name]= item
          })
        }
    })
    state.types = Object.assign({}, state.types)
  },
  addTag (state, item) {
    state.tags[item.name] = item
    if (state.types[item.type]) state.types[item.type].tags[item.name]= item
    state.count++
  },
  toggleSelected (state, item) {
    
  },
  setSelected (state, selected) {
    state.selected = selected
  },
  removeSelected (state , item) {
   return removeSelected(state, item)
  },
  addSelected (state, item) {
    var isNew = !removeSelected(state, item)
    state.selected.push(item)
    return isNew
  }
};

function removeSelected(state,item){
   var present = false
    //state.selected.filter(t => t.name != item.name);
    //state.selected = state.selected.filter(t => t.name != item.name)
    //state.selected.splice(state.selected.findIndex(item => item.name === item.name), 1)
    for (var i = state.selected.length - 1; i >= 0; --i) {
        if (state.selected[i].name == item.name) {
            state.selected.splice(i,1);
            present = true
        }
    }
    return present
}